import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_SCHEDULE_FOR_DASHBOARD } from "../Schema/Dashboard";

const useGetScheduleForDashboard = ({ page, limit, day, courseId }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const { refetch } = useQuery(GET_SCHEDULE_FOR_DASHBOARD, {
    variables: {
      page,
      limit,
      day,
      courseId,
    },
    onCompleted: ({ getScheduleForDashboard }) => {
      // console.log("getScheduleForDashboard::", getScheduleForDashboard)
      setTableData(getScheduleForDashboard?.classData);
      setTotalCount(getScheduleForDashboard?.totalCount);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, [page, limit, day, courseId]);

  return { totalCount, tableData, loading };
};

export default useGetScheduleForDashboard;
